// extracted by css-extract-rspack-plugin
export default {"body":"Edit__body--pafyK","bottomButtonsArea":"Edit__bottomButtonsArea--mPDyc","help":"Edit__help--IMjL0"};